import React, { useState, useEffect } from 'react';
import api from '../../../services/api';

function PartnerActionsTab({ partner, filter, onClearFilter }) {
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (partner) {
      fetchActions();
    }
  }, [partner, filter]);

  const fetchActions = async () => {
    try {
      setLoading(true);
      const response = await api.getPartnerActions(partner._id);
      let allActions = response.data.actions || [];
      
      // Apply filter if present
      if (filter && filter.type === 'config') {
        console.log('Filtering actions by config ID:', filter.id);
        allActions = allActions.filter(action => {
          const actionConfigId = typeof action.actionConfigId === 'object' && action.actionConfigId._id 
            ? action.actionConfigId._id 
            : action.actionConfigId;
          return actionConfigId?.toString() === filter.id?.toString();
        });
        console.log('Filtered actions:', allActions.length);
      }
      
      setActions(allActions);
    } catch (err) {
      console.error('Error fetching actions:', err);
      setMessage({ type: 'error', text: 'Failed to load actions' });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
        Loading actions...
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginBottom: '20px', fontSize: '20px' }}>
        Actions
      </h2>

      {filter && (
        <div style={{
          padding: '12px 16px',
          marginBottom: '20px',
          borderRadius: '6px',
          backgroundColor: '#eff6ff',
          border: '1px solid #3b82f6',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ fontSize: '14px', color: '#1e40af' }}>
            <strong>Filtered by:</strong> Action Config "{filter.name}"
          </div>
          <button
            onClick={onClearFilter}
            style={{
              padding: '4px 12px',
              backgroundColor: 'white',
              border: '1px solid #3b82f6',
              borderRadius: '4px',
              fontSize: '13px',
              cursor: 'pointer',
              color: '#1e40af'
            }}
          >
            Clear Filter
          </button>
        </div>
      )}

      {message && (
        <div style={{
          padding: '12px',
          marginBottom: '20px',
          borderRadius: '6px',
          backgroundColor: message.type === 'success' ? '#dcfce7' : '#fee2e2',
          color: message.type === 'success' ? '#166534' : '#dc2626',
          border: `1px solid ${message.type === 'success' ? '#86efac' : '#fca5a5'}`
        }}>
          {message.text}
        </div>
      )}

      {actions.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          color: '#6b7280'
        }}>
          <p>No actions found{filter ? ' for this filter' : ''}</p>
        </div>
      ) : (
        <div style={{
          backgroundColor: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          overflow: 'hidden'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#6b7280' }}>
                  User ID
                </th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#6b7280' }}>
                  Action Type
                </th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#6b7280' }}>
                  Metadata
                </th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#6b7280' }}>
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {actions.map((action, index) => (
                <tr 
                  key={action._id}
                  style={{
                    borderBottom: index < actions.length - 1 ? '1px solid #f3f4f6' : 'none'
                  }}
                >
                  <td style={{ padding: '12px 16px', fontSize: '14px', color: '#111827' }}>
                    <span style={{ fontFamily: 'monospace', fontSize: '13px' }}>
                      {action.userId?.substring(0, 8)}...
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '14px', color: '#111827' }}>
                    {action.actionType}
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '13px', color: '#6b7280' }}>
                    {action.metadata ? (
                      <details style={{ cursor: 'pointer' }}>
                        <summary style={{ fontSize: '13px', color: '#4f46e5' }}>
                          View metadata
                        </summary>
                        <pre style={{
                          marginTop: '8px',
                          padding: '8px',
                          backgroundColor: '#f9fafb',
                          borderRadius: '4px',
                          fontSize: '12px',
                          overflow: 'auto',
                          maxWidth: '300px'
                        }}>
                          {JSON.stringify(action.metadata, null, 2)}
                        </pre>
                      </details>
                    ) : (
                      <span style={{ color: '#9ca3af' }}>No metadata</span>
                    )}
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '13px', color: '#6b7280' }}>
                    {new Date(action.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {actions.length > 0 && (
        <div style={{
          marginTop: '16px',
          fontSize: '14px',
          color: '#6b7280',
          textAlign: 'center'
        }}>
          Total: {actions.length} action{actions.length !== 1 ? 's' : ''}
        </div>
      )}
    </div>
  );
}

export default PartnerActionsTab;
